import { statusOf } from "./scanHelpers";

const RETRY_DELAY_MS = 1000;

export const newScanId = () =>
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

// A scan whose answer was lost (timeout, dropped connection) is sent once more with the same scan id, so the
// server answers with that scan's own result, not "already used". An answer with a status is final.
export const scanWithRetry = async <T>(
  send: (scanId: string) => Promise<T>,
  scanId = newScanId(),
  delayMs = RETRY_DELAY_MS
): Promise<T> => {
  try {
    return await send(scanId);
  } catch (error) {
    if (statusOf(error)) throw error;
    await new Promise((resolve) => setTimeout(resolve, delayMs));
    return send(scanId);
  }
};
